'use strict';

import $ from 'jquery';
import 'magnific-popup'; // eslint-disable-line

let herovideo = {
  closeAfterFirst: false,
  onPlayerReady: function (event) {
    event.target.playVideo();
  },
  getMultiVideoData: function () {

    let heroEls = $('.hero.multivideo');

    if (!heroEls.length) {
      heroEls = $('.hero.multiVideo');
    }

    if (heroEls.length && !window.YT) {
      // add api
      let tag = document.createElement('script');
      tag.src = '//www.youtube.com/iframe_api';
      let firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }


    $.each(heroEls, function () {

      const heroId = $(this).attr('data-id'),
        btn = $(this).find('a.button'),
        overlayData = window.overlayData && window.overlayData[heroId] ? window.overlayData[heroId] : false;

      herovideo.closeAfterFirst = btn.attr('data-video-close') === '1' ? true : false;

      if (heroId && overlayData) herovideo.initMultiVideoHero(overlayData, $(this), btn, heroId);

    });

  }, // getMultiVideoData
  initMultiVideoHero: function (overlayData, heroEl, btn, heroId) {

    const videoId = overlayData.video_0 && overlayData.video_0.id ? overlayData.video_0.id : false;
    const extraVideos = $('<ul></ul>');

    for (let key in overlayData) {
      // skip loop if the property is from prototype
      if (!Object.prototype.hasOwnProperty.call(overlayData, key)) {
        continue;
      } else if (key !== 'video_0' && key.indexOf('video_') !== -1 && overlayData[key].id) {
        let li = $('<li></li>'),
          a = $('<a></a>'),
          img = $('<img />');

        a.attr('href', (overlayData[key].id ? 'https://www.youtube.com/watch?v=' + overlayData[key].id : ''));
        a.attr('title', (overlayData[key].name ? overlayData[key].name : ''));
        a.attr('data-video-id', (overlayData[key].id ? overlayData[key].id : ''));

        if (overlayData[key].img) {
          a.css('background-image', 'url(' + overlayData[key].img + ')');
        }

        img.attr('src', (overlayData[key].img ? overlayData[key].img : ''));
        img.attr('alt', (overlayData[key].name ? overlayData[key].name : ''));

        a.append(img);
        li.append(a);
        extraVideos.append(li);

      }
    } // for

    // clone some-buttons from footer, choose the ones we want
    const cloneButtons = $('.share-buttons.proper').length ? $('.share-buttons.proper:first').clone() : $('<div></div>');
    $(cloneButtons).find('li').each(function () {

      let htmlClass = $(this).attr('class') ? $(this).attr('class') : false;
      let useThese = ['facebook', 'twitter', 'google', 'linkedin', 'whatsapp', 'envelope'];
      let keepThis = false;

      for (let i = 0; i < useThese.length; i++) {
        if (htmlClass && htmlClass.indexOf(useThese[i]) !== -1) {
          keepThis = true;
        }
      }

      if (!keepThis) {
        $(this).remove();
      }

    });

    window.onPlayerStateChange = function (event) {

      // without this mfp won't work
      let magnificPopup = $.magnificPopup.instance; // eslint-disable-line

      if (event.data === 0) { // 0 == ENDED

        // close after first video ?
        if (herovideo.closeAfterFirst) {
          $.magnificPopup.close();
        } else {
          $('.multivideo-overlay-text:first').fadeIn('fast');
        }

      } else if ($('.multivideo-overlay-text:first').is(':visible')) {
        $('.multivideo-overlay-text:first').hide();
      }

    }; // onPlayerStateChange

    if (videoId) {

      let content = '<div class="multivideo-overlay-container">' +
        '<div class="multivideo-overlay-video-wrap">' +
        '<div id="multivideo-overlay-video"></div>' +
        '<div class="multivideo-overlay-text overlay_bgEl_' + heroId + '">' +
        '<div class="text' + (overlayData.overlayContentPosition ? ' ' + overlayData.overlayContentPosition : '') + '">' + overlayData.text +
        extraVideos[0].outerHTML +
        '</div>' +
        '</div>' +
        '<div class="some">' +
        cloneButtons[0].outerHTML +
        '</div>' +
        '</div>' +
        '</div>';

      // watch video -button
      btn.magnificPopup({
        mainClass: 'multivideo-overlay',
        callbacks: {
          beforeOpen: function () {
            // make sure yt is ready, else go to YouTube
            if (!$(document.body).hasClass('ytPlayerReady')) {
              console.log('video not ready');
              return false;
            }
          },
          open: function () {
            let YT = window.YT;
            window.player = new YT.Player('multivideo-overlay-video', {
              height: '315',
              width: '560',
              videoId: videoId,
              playerVars: { rel: 0 },
              events: {
                'onStateChange': window.onPlayerStateChange,
                'onReady': herovideo.onPlayerReady
              }
            });
          }
        },
        items: {
          src: content,
          type: 'inline' // this overrides default type
        }
      });
    } // videoId
  }, // initMultiVideoHero
  init: function () {
    // multivideo custom element has it's own functions
    console.log('herovideo.init()');
    this.getMultiVideoData();
    window.heroVideo = this.initMultiVideoHero;
  }
};

export default herovideo;
